import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables';
import { mq } from '../../helpers';
import { Section } from '../../styles/Components';

export const SignUpSection = styled(Section)`
   margin: 0 auto 40px;
   width: 50%;
   max-width: 500px;
   min-width: 350px;
   padding-bottom: 30px;
   order: 2;

   ${mq('max', '768px')} {
     min-width: 0;
     max-width: initial;
     width: 100%;
     padding: 0 16px 30px;
   }
 
   form {
     margin: 0;
   }
 
   .form-control {
     font-family: Euclid, sans-serif;
     font-size: 16px;
     line-height: 20px;
     padding: 10px 0;
     width: 100%;
 
     ::placeholder {
       color: ${gsColors.paleSlate};
     }
 
     &:focus {
       outline: 0;
     }
 
     &.name-first,
     &.phone-number,
     &.email-address,
     &.password {
       padding-left: 30px;
     }
   }
   
   .remember-me-toggle{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;

      button{
        padding: 15px 0;
        font-size: 12px;
        min-width: 0;
      }

      div > label {
        display: flex;
        padding: 0;

        .remember-me-text {
          font-family: Euclid, sans-serif;
          color: black;
          font-size: 16px;
          font-weight: 400;
          padding-left: 12px;
        }
      }

      .remember-me-text{
        color: ${gsColors.darkEggplant};
        font-size: 13px;
        padding-right: 5px;
      }
    }

  .field-container {
    margin-top: 20px;
 
    ${mq('min', '768px')} {
      margin-left: auto;
      margin-right: auto;
      max-width: 380px;
    }

    .error-message {
      color: ${gsColors.sunsetOrange};
      font-size: 16px !important;
    }
    
    .input-error {
      color: ${gsColors.sunsetOrange};
      border-bottom: 1px solid ${gsColors.sunsetOrange} !important;
    }
 
    &.name {
      display: flex;
      justify-content: space-between;

      > div {
        width: calc(50% - 10px);
      }

      .name-first-container {
        position: relative;

        img {
          position: absolute;
          top: 11px;
          left: 0;
        }
      }
    }

    &.phone-container, &.password-container, &.email-container {
      position: relative;

      img {
        position: absolute;
        left: 0;
      }
    }

    &.phone-container > img {
      top: 11px;
    }

    &.email-container > img {
      top: 14px;
    }

    &.password-container > img {
      top: 10.5px;
    }

    &.phone-input-container {
      width: 100%;
      position: relative;

      label {
        color: #000;
        opacity: 0.5;
        position: absolute;
        font-family: 'Euclid';
        font-size: 18px;
        z-index: -1;
        top: 10px;
        transition: all .1s ease;

        &.active {
          font-size: 11px;
          top: -2px;
          left: 0;
          line-height: 120%;
          letter-spacing: 0.22px;
        }
      }

      .react-international-phone-input-container {
        width: 100%;
        align-items: flex-end;

        .react-international-phone-country-selector {
          box-sizing: border-box;
          border: none;
          border-bottom: 1px solid #000;

          button {
            height: 100%;
            box-sizing: border-box;
            border: none;
            margin: 8px 0;
            background-color: transparent;
          }

          ul {
            z-index: 2000;
          }
        }

        input {
          height: 100%;
          box-sizing: border-box;
          width: 100%;
          border: none;
          border-bottom: 1px solid #000;
          font-size: 18px;
          font-family: Euclid;
          line-height: 120%;
          border-radius: 0;
          letter-spacing: 0.36px;
          padding: 12px 0;
          position: relative;
          background-color: transparent;

          &:focus {
            outline: none;
          }
        }
      }

      &.phone-error {
        .react-international-phone-input-container {
          .react-international-phone-country-selector {  
            border-bottom: 1px solid ${gsColors.sunsetOrange};
          }
        }
      }
    }

    &.terms-container {
      div > label {
        padding: 0;
        display: flex;

        .box {
          margin-right: 12px;
        }

        span {
          font-family: Euclid;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 160%;
            letter-spacing: 0.72px;          
          a {
            margin: 0 3px;
            color: ${gsColors.sunsetOrange}          
          }
        }
      }
    }
  }
 
   .invalid-feedback {
     color: ${gsColors.sunsetOrange};
     font-family: Euclid;
     font-size: 16px;
     font-weight: 400;
     margin-top: 8px 0 0;
     line-height: 20px;
 
     ${mq('max', '768px')} {
      font-size: 13px;
     };
   }
 
   .field-hint {
     color: ${gsColors.venus};
     font-family: Euclid;
     font-size: 12px;
     font-style: normal;
     font-weight: 400;
     line-height: 138%; /* 16.56px */
     margin-top: 8px;
 
     ${mq('min', '768px')} {
       text-align: left;
     }
   }
 
   .divider-with-text {
     line-height: 20px;
     margin: 20px 0;
     position: relative;
     text-align: center;
 
     ${mq('min', '768px')} {
       margin-left: auto;
       margin-right: auto;
       max-width: 330px;
     }
 
     &:before {
       position: absolute;
       top: 50%;
       transform: translate3d(0, -50%, 0);
       background-color: ${gsColors.ebb};
       content: '';
       left: 0;
       width: 100%;
       height: 1px;
     }
 
     span {
       background-color: ${gsColors.white};
       color: ${gsColors.black};
       display: inline-block;
       padding: 0 20px;
       position: relative;
       text-align: center;
       font-family: Euclid;
       font-size: 16px;
       font-style: normal;
       font-weight: 600;
       line-height: 138%; /* 22.08px */
     }


   }

   .fb-login {
      border-color: ${gsColors.black};
      span {
        color: ${gsColors.black};
      }
   }
 `;